import { Route, Switch, useLocation } from "wouter";
import { Login } from "./pages/Login";
import { Home } from "./pages/Home";
import { InvoiceEditor } from "./pages/InvoiceEditor";
import { InvoiceDetail } from "./pages/InvoiceDetail";
import { Settings } from "./pages/Settings";
import { Projection } from "./pages/Projection";
import { AppNav } from "./components/AppNav";

export function App() {
  const [location] = useLocation();
  const isLogin = location === "/login";
  return (
    <>
      {!isLogin && <AppNav />}
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/" component={Home} />
        <Route path="/invoices/new" component={InvoiceEditor} />
        <Route path="/invoices/:slug/edit">
          {(p: { slug: string }) => <InvoiceEditor slug={p.slug} />}
        </Route>
        <Route path="/invoices/:slug">
          {(p: { slug: string }) => <InvoiceDetail slug={p.slug} />}
        </Route>
        <Route path="/projection" component={Projection} />
        <Route path="/settings" component={Settings} />
        <Route>
          <main class="app-shell">
            <p class="muted">404</p>
          </main>
        </Route>
      </Switch>
    </>
  );
}
